import React from 'react'
import ChatNow from "../chatnow"
const GetPaid = () => {
    return (
        <div className='relative m-5' id='getpaid'>
            <img src='/assets/images/lawyer-with-a-client-desktop.jpg' alt="" className='w-screen hidden md:block' />
            <img src='/assets/images/lawyer-with-a-client-mobile.jpg' alt="" className='w-screen md:hidden block' />

            <div className='container mx-auto '>
                <div className='absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 z-10 max-md:w-[100%] lg:max-w-[80%] xl:max-w-[50%]'>
                    <h2 className='font-medium text-5xl md:text-7xl text-white text-center max-sm:px-5'>If You Don’t Get Paid, We Don’t Get Paid.</h2>
                    <p className='text-white font-light mt-4 text-center max-sm:px-10'>
                        Consectetur We Bring together insurance expertise and the ease of next-gen tech to create policies tailored to the needs of startups and freelancers.
                    </p>
                </div>
            </div>

            <div className='absolute max-sm:left-0 right-0 bottom-6 sm:bottom-14 sm:right-14 px-6'>
                <ChatNow text="Chat now!" />
            </div>
        </div>
    )
}

export default GetPaid